import appleLie from '../assets/images/digital-home-apple-lie-2025.webp'
import houseYarn from '../assets/images/digital-house-yarn-2025.webp'

import tank3 from '../assets/images/digital-tank-3-2023.webp'
import tank4 from '../assets/images/digital-tank-4-2023.webp'

import tank1 from '../assets/images/digital-tank-1-2022.webp'
import tank2 from '../assets/images/digital-tank-2-2022.webp'

export const digitalImages = [
    {
        src: appleLie,
        alt: "",
        title: "Home is where the apple lie",
        year: "2025"
    },
    {
        src: houseYarn,
        alt: "",
        title: "House and Yarn (Borders)",
        year: 2025
    },
    {
        src: tank4,
        alt: "",
        title: "Tank Series IV",
        year: "2023"
    },
    {
        src: tank3,
        alt: "",
        title: "Tank Series III",
        year: "2023"
    },
    {
        src: tank2,
        alt: "",
        title: "Tank Series II",
        year: "2022"
    },
    {
        src: tank1,
        alt: "",
        title: "Tank Series I",
        year: "2022"
    },
]